/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { SharedModule } from '../shared/shared.module';
import { CommentThreadModule } from '../comment-thread/comment-thread.module';
import { UtEditorModule } from '../common/ut-editor/ut-editor.module';
import { ArticleModule } from '../article/article.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { ItemActionsModule } from '../item-actions/item-actions.module';
import { ArticlesPageComponent } from './articles-page.component';
import { ArticlePageComponent } from './article-page.component';
import { ArticleFormPageComponent } from './article-form-page.component';

// Not standalone, for the same reason as CommunityFeedModule: the action bar and comment thread pull in
// UpgradeModule. ArticleModule supplies the existing slug input and tag selector.
@NgModule({
  imports: [CdkMenuModule, CommonModule, UIRouterModule, SharedModule, CommonComponentsModule, CommentThreadModule, UtEditorModule, ArticleModule, ItemActionsModule, CommunityFeedModule],
  declarations: [ArticlesPageComponent, ArticlePageComponent, ArticleFormPageComponent],
  exports: [ArticlesPageComponent, ArticlePageComponent, ArticleFormPageComponent],
})
class ArticlesPageModule {}

export { ArticlesPageModule };
